import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components';

export const ScNewTermsAndConditionsModal = styled.div`
  display: flex;
  justify-content: space-between;

  p {
    line-height: 20px;
  }

  .text-block {
    display: flex;
    height: 100%;
    max-height: 320px;
    overflow-y: auto;
  }

  .text-block::-webkit-scrollbar {
    width: 4px;
  }

  .text-block::-webkit-scrollbar-thumb:hover {
    background-color: ${({ theme }) => theme.grayColor1};
    cursor: pointer;
  }

  .text-block::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.grayColor6};
    border-radius: 6px;
  }

  .text-block::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 6px;
  }

  .checkbox-block {
    display: flex;
    margin: 32px 0 0 0;
  }

  .button-block {
    display: flex;
    margin: 32px auto 0;
    width: 100%;
    max-width: 232px;
  }

  @media (${device.mobileS}) {
    flex-direction: column;
    align-items: center;
    max-height: 100svh;

    .button-block {
      min-width: 100%;
    }

    .text-block {
      flex-grow: 1;
      min-height: 0;
      max-height: calc(100svh - 250px);
    }
  }
`;
